import ko = require('knockout');

export default class ValidateableViewModel {
    errors: KnockoutValidationErrors;
    generalErrors: KnockoutObservableArray<string>;
    isSetup: boolean;
    isValidating: boolean;

    init = () => {
        this.isSetup = true;
        this.errors = ko.validation.group(this, {deep: true});
    };

    isValid = () => {
        this.isValidating = true;
        if (!this.isSetup) {
            this.init();
        }

        this.errors.showAllMessages();
        let hasError = this.errors().filter(error => error !== "").length === 0;
        this.isValidating = false;
        return hasError;
    };

    addServerErrors = (data, self) => {
        var parsed = JSON.parse(data.responseText);
        self.generalErrors.removeAll();
        if (typeof parsed.modelState !== 'undefined') {
            parsed.modelState.forEach((errors) => {
                errors.forEach((error) => {
                    self.generalErrors.push(error);
                });
            });
        }
    };

    customValidation = (isValid: () => boolean) =>
        ko.observable<boolean>().extend({ validation: [{ validator: isValid }] });

    customValidations = (validations: (() => boolean)[]) => {
        var observable = ko.observable<boolean>();
        validations.forEach((isValid)=> {
            observable = observable.extend({ validation: [{ validator: isValid, message: '' }] });
        });
        return observable;
    };
}
